// extracted by mini-css-extract-plugin
module.exports = {"mobileMenu":"Mobile_mobileMenu__1B6wf","moreBtn":"Mobile_moreBtn__2Ok7R","dropdown":"Mobile_dropdown__lZKVr","collapsed":"Mobile_collapsed__2GiUS"};